export default {
  carousel: {
    imgMissing: '图像丢失',
    pendingImg: '请在下方操作栏选择显示的图像',
    upload: '上传屏显',
    uploading: '正在上传',
    add: '新增页面',
  },
  pages: {
    systemPage: {
      home: '首页',
      mouseRt: '按键行程',
    },
    side: {
      title: '组件样式',
      tabPreset: '预设',
      tabPicture: '图片',
      tabText: '文字',
    },
    picture: {
      add: '添加素材仅支持 JPG、PNG、GIF',
    },
    text: {
      inputPlaceholder: '请输入文本',
      fontSize: '文字大小',
      fontSmall: '小',
      fontNormal: '中',
      fontLarge: '大',
      fontColor: '文字颜色',
      bgColor: '背景颜色',
      preview: '预览',
      minimize: '缩小',
    },
  },
  player: {
    displayTip: '*勾选进行显示',
    sortTip: '*拖动进行排序',
    tabDisplay: '自定义显示',
    tabSort: '播放顺序',
    imgMissing: '图像丢失',
    minDisplay: '至少显示一项播放内容',
  },
  routeDialog: {
    title: '未上传内容提示',
    description: '切换页面，未上传的记录会被清除哦，要先上传屏显吗？',
    cancelText: '离开',
    confirmText: '上传屏显',
  },
  pictureEditDialog: {
    title: '素材命名',
    placeholder: '请输入素材名称',
    error: '名称不能超过 {limit} 字符',
  },
  pictureDeleteDialog: {
    title: '删除素材',
    occupancyTip:
      '删除后软件内将不再保留此素材。设备屏显仍会继续显示当前画面，如需更换或重新编辑，需重新上传',
    confirmTip: '删除后需再次上传，确认将此素材删除',
  },
  carouselDeleteDialog: {
    title: '删除屏显',
    description: '删除后该页面将从轮播中移除，确认删除此屏显',
  },
}
